import { TabView, TabPanel } from 'primereact/tabview';
import Icon from '../../../components/Icon/Icon';
import Overview from '../Overview';
import Card from '../../../components/Card/Card';
import styles from '../Dashboard.module.css';
import { useState, useEffect } from 'react';

import { generatePFMMetrics } from '../../../utils/common.utils';
import { useSelector } from 'react-redux';
import metricNameMapping from '../../../utils/getMetricMapping';
import Heading from '../../../components/Heading/Heading';
import CONSTANTS from '../../../constants';
import DashboardChart from '../Charts/Line Chart/DashboardChart';

const PFMDashboard = (props) => {
	const [metrics, setMetrics] = useState();
	const filter = useSelector((state) => state.ui.filter);

	useEffect(() => {
		generatePFMMetrics(setMetrics);
	}, []);

	// console.log('metrics', metrics);

	const consentMetrics = metrics?.consentMetrics;
	const customerMetrics = metrics?.customerMetrics;

	//Consent Metrics
	const yesterdayConsents = consentMetrics?.filter(
		(metric) => metric.intervalTimeType === 'Yesterday'
	);
	const MTDConsents = consentMetrics?.filter(
		(metric) => metric.intervalTimeType === 'MTD'
	);
	const YTDConsents = consentMetrics?.filter(
		(metric) => metric.intervalTimeType === 'YTD'
	);
	// const summaryConsents = consentMetrics?.filter(
	// 	(metric) => metric.intervalTimeType === 'Summary'
	// );

	//Customer Metrics
	const yesterdayCustomers = customerMetrics?.filter(
		(metric) => metric.intervalTimeType === 'Yesterday'
	);
	const MTDCustomers = customerMetrics?.filter(
		(metric) => metric.intervalTimeType === 'MTD'
	);
	const YTDCustomers = customerMetrics?.filter(
		(metric) => metric.intervalTimeType === 'YTD'
	);
	// const summaryCustomers = customerMetrics?.filter(
	// 	(metric) => metric.intervalTimeType === 'Summary'
	// );

	const getCustomerArray = () => {
		switch (filter) {
			case 'Last 24 hours':
				return yesterdayCustomers;
			case 'Month to date':
				return MTDCustomers;
			case 'Year to date':
				return YTDCustomers;
			// case 'All time':
			// 	return summaryCustomers;
			default:
				return yesterdayCustomers;
		}
	};

	const getConsentArray = () => {
		switch (filter) {
			case 'Last 24 hours':
				return yesterdayConsents;
			case 'Month to date':
				return MTDConsents;
			case 'Year to date':
				return YTDConsents;
			// case 'All time':
			// 	return summaryConsents;
			default:
				return yesterdayConsents;
		}
	};

	const customerArray = getCustomerArray();
	const consentArray = getConsentArray();
	const expiringConsents = consentMetrics?.find(
		(metric) => metric.metricName === 'expiring_consents_15d'
	)?.metricValue;

	return (
		<div className="main">
			<Heading>Dashboard</Heading>
			<TabView>
				<TabPanel header="Customer" leftIcon={<Icon icon="verified_user" />}>
					<div>
						<Overview data={customerMetrics || []} />
						<div className={styles['tab-content__container']}>
							{customerArray?.map((metric) => (
								<Card
									key={metric.metricName}
									title={metricNameMapping(metric.metricName)}
									subtitle={metric.metricValue}
								/>
							))}
						</div>
					</div>
					<hr />
					<DashboardChart filterOptions={CONSTANTS.pfmCustomerFilterOptions} />
				</TabPanel>
				<TabPanel header="Consent" leftIcon={<Icon icon="send" />}>
					<div>
						<Overview data={consentMetrics || []} />
						<div className={styles['tab-content__container']}>
							{consentArray?.map((metric) => (
								<Card
									key={metric.metricName}
									title={metricNameMapping(metric.metricName)}
									subtitle={metric.metricValue}
								/>
							))}

							<div className={styles.expiring}>
								<Card
									title="Expiring Consents"
									subtitle={
										expiringConsents === undefined ? 0 : expiringConsents
									}
								/>
								<div className={styles['expiring-note']}>
									Note: Expiring consents are unaffected by time range
								</div>
							</div>
						</div>
					</div>
					<hr />
					<DashboardChart filterOptions={CONSTANTS.consentFilterOptions} />
				</TabPanel>
			</TabView>
		</div>
	);
};

export default PFMDashboard;
